export default __webpack_public_path__ + "static/media/csvChecked.f82d4a22.svg";